export enum ContentTreeItemType {
    Container = 'container',
    Component = 'component',
    Outlet = 'outlet'
}
